import { render, staticRenderFns } from "./svgBasalam.vue?vue&type=template&id=76adbcc5"
import script from "./svgBasalam.vue?vue&type=script&lang=js"
export * from "./svgBasalam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports